import React, { CSSProperties, useMemo } from 'react';
import classNames from 'classnames';
import type { BringgFontIcons } from 'types/icon-types';
import './bringg-icon.scss';

export const ICON_BASE_NAME = 'bringg-icon';

interface Props {
	iconName: BringgFontIcons;
	className?: string;
	style?: CSSProperties;
	spin?: boolean;
	circle?: boolean;
	rotate90?: boolean;
	color?: string;
	['data-test-id']?: string;
}

const BringgIcon = (props: Props) => {
	const {
		iconName,
		className,
		spin,
		rotate90,
		circle,
		style,
		color,
		['data-test-id']: dataTestId,
		...restOfProps
	} = props;
	const classes = classNames(`${ICON_BASE_NAME} ${ICON_BASE_NAME}-${iconName} ${className || ''}`, {
		spin,
		circle,
		'rotate-90': rotate90
	});

	const iconInlineStyle = useMemo(() => {
		const iconStyle = style || {};
		if (color) {
			iconStyle.color = color;
		}
		return iconStyle;
	}, [color]);

	return <i className={classes} style={iconInlineStyle} data-test-id={dataTestId} {...restOfProps} />;
};

export default BringgIcon;
